import axios from "axios";
import { message } from "antd";
import { ApiUrl, baseUrl } from "./Api";
import PersianDate from "persian-date";
import React from "react";
import moment from "moment-jalaali";
import FileDownload from "js-file-download";

export function getTimeObject(sec) {
  let difference = sec;

  let days = Math.floor(difference / 60 / 60 / 24);
  difference -= days * 60 * 60 * 24;

  let hours = Math.floor(difference / 60 / 60);
  difference -= hours * 60 * 60;

  let minutes = Math.floor(difference / 60);
  difference -= minutes * 60;

  let seconds = Math.ceil(difference);

  return { days, hours, minutes, seconds };
}

export function getDateString(date) {
  if (!date) {
    return "";
  }

  try {
    let time = "";

    time = moment(date).format("jYYYY/jMM/jDD");

    return time;
  } catch (e) {
    return date;
  }
}

export function convertNumToEn(str, convert = false) {
  const persianNumbers = [
      /۰/g,
      /۱/g,
      /۲/g,
      /۳/g,
      /۴/g,
      /۵/g,
      /۶/g,
      /۷/g,
      /۸/g,
      /۹/g,
    ],
    arabicNumbers = [
      /٠/g,
      /١/g,
      /٢/g,
      /٣/g,
      /٤/g,
      /٥/g,
      /٦/g,
      /٧/g,
      /٨/g,
      /٩/g,
    ];

  if (typeof str === "string") {
    for (let i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
    }
  }

  return convert ? Number(str) : str;
}

export function convertNumToFa(str, convert = false) {
  const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

  str = str.toString();

  if (typeof str === "string") {
    for (let i = 0; i < 10; i++) {
      let p = persianNumbers[i];

      if (str.replaceAll) {
        str = str.replaceAll(i, p);
      } else {
        str = str.replace(i, p);
      }
    }
  }
  return convert ? Number(str) : str;
}

export const logType = {
  info: "information",
  warn: "warning",
  error: "error",
};
export const Log = (entry, type = logType.info) => {
  let environment = process.env.NODE_ENV || "development";
  if (environment !== "development") {
    return false;
  }

  if (type === logType.info) {
    console.log(entry);
  } else if (type === logType.warn) {
    console.warn(entry);
  } else if (type === logType.error) {
    console.error(entry);
  }
};

export function checkValue(val) {
  return typeof val !== "undefined" && val !== null && val !== "";
}

export function getHoursMinutesTime(timestamp, format = "HH:mm") {
  if (!timestamp || typeof timestamp !== "number") {
    return "--:--";
  }

  return new PersianDate(timestamp).format(format);
}

// function isSafari() {
// 	return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
// }

export function isLogin() {
  const token = localStorage.getItem("access_token");
  const ref_token = localStorage.getItem("refresh_token");

  if (token || ref_token) {
    return true;
  }

  const phone = sessionStorage.getItem("phone");
  const code = sessionStorage.getItem("code");

  if (phone && code) {
    tokenHandle()
      .then((resp) => Log(resp))
      .catch((err) => Log(err, logType.error));
    return true;
  }

  return false;
}

export async function tokenHandle() {
  return new Promise((resolve, reject) => {
    let username = sessionStorage.getItem("phone");
    let password = sessionStorage.getItem("code");

    if (!username || !password) {
      clearStorage();
      if (window.location.pathname.search("/login") < 0) {
        window.location.pathname = "/login";
      }
      return reject("no token!");
    }

    const params = new URLSearchParams();
    params.append("grant_type", "otp");
    params.append("username", convertNumToEn(username));
    params.append("password", convertNumToEn(password));
    params.append("tag", "client");

    axios
      .post(baseUrl + ApiUrl.register.getToken_post, params, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        auth: {
          username: "sampleClient",
          password: "sampleSecret",
        },
      })
      .then((resp) => {
        const {
          access_token,
          refresh_token,
          expires_in /*token_type, scope*/,
        } = resp.data;

        if (access_token) {
          localStorage.setItem("access_token", access_token);
        }

        if (refresh_token) {
          localStorage.setItem("refresh_token", refresh_token);
        }

        if (expires_in) {
          localStorage.setItem("expires_in", expires_in);
        }

        if (
          window.location.pathname.search("/login") > -1 ||
          window.location.pathname.search("/linkedin") > -1
        ) {
          const searchParams = new URLSearchParams(window.location.search);
          const _continue = decodeURI(searchParams.get("continue") || "/home");
          window.location.href = _continue;
          sendEmbedToken(searchParams);
        } else {
          window.location.reload();
        }

        return resolve(true);
      })
      .catch((err) => {
        message.error("خطا در دریافت کلید امنیتی!");

        clearStorage();

        if (window.location.pathname.search("/login") < 0) {
          window.location.pathname = "/login";
        }

        return reject(false);
      });
  });
}

const KB = 1 << 10;
const MB = 1 << 20;

export function calcBytes(value) {
  let mag = Math.abs(value);

  let unit;
  if (mag >= MB) {
    unit = "MB";
    value = value / MB;
  } else if (mag >= KB) {
    unit = "KB";
    value = value / KB;
  } else {
    unit = "B";
  }

  return value.toFixed(0).replace(/(?:\.0*|(\.[^0]+)0+)$/, "$1") + " " + unit;
}

export function getNormalizeObj(array) {
  let normalize = {};
  if (array && array.length > 0) {
    array.forEach((i) => {
      normalize[i.id] = i;
    });
  }

  return normalize;
}

export function getFiledValue(data) {
  if (!data || !data.fields) {
    return "";
  }

  let result = "";
  // if (data && (data.type === "string" || data.type === "string") && data.fields) {
  if (data && data.fields) {
    result = [...data.fields];
  }

  return result;
}

export const sendEmbedToken = (searchParams) => {
  const emebed = !!searchParams.get("embed");
  const token = localStorage.getItem("access_token");
  if (token && emebed) {
    const message = { type: "token", data: token };
    window.parent.postMessage(message, "https://lawin.co");
  }
};

export function getPersianDateObj(date) {
  if (!date) {
    return "";
  }

  const d = new Date(Number(date));
  let result = new PersianDate(d).format("YYYY-MM-DD-MMMM-dddd-HH-MM");
  let [year, month, day, monthName, dayName, hours, minuets] =
    result.split("-");

  return {
    year,
    month,
    day,
    monthName,
    dayName,
    hours,
    minuets,
  };
}

export function dataURLtoFile(dataUrl, filename) {
  let arr = dataUrl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export function debounce(func, wait, immediate) {
  let timeout;

  return (...args) => {
    let context = this;

    let later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    let callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}

export function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}

export function isNumber(value) {
  return typeof value === "number" && isFinite(value);
}

export function isNumberObject(n) {
  return Object.prototype.toString.apply(n) === "[object Number]";
}

export function isCustomNumber(n) {
  return isNumber(n) || isNumberObject(n);
}

export function getSessionStatus(status) {
  if (!status || !status.trim().length) {
    return "نامشخص";
  }

  const statusDic = {
    OPEN: "منتظر تایید وکیل",
    CLOSED: "به اتمام رسیده",
    READY_FOR_PAYMENT: "در انتظار پرداخت",
    LOOKING_FOR_LAWYER: "منتظر تایید وکیل",
    STARTED: "در حال انجام",
    CLOSED_BY_ADMIN: "بسته شده توسط مدیر",
    RECHARGE_NEEDED: "احتیاج به افزایش اعتبار",
  };

  return statusDic[status.toUpperCase()];
}

export function getArrayPersianDate(str) {
  if (!checkValue(str)) return "";
  let d = convertNumToEn(str);
  if (typeof d === "string" && d.lastIndexOf("/") > -1) {
    let array = d.split("/");
    if (array && array.length > 2) {
      for (let i = 0; i < array.length; i++) {
        array[i] = Number(array[i]);
      }
      return [...array, 0, 0];
    }
  }

  return "";
}

export function hasOwnNestedProperty(obj, key) {
  return key.split(".").every(function (x) {
    // eslint-disable-next-line
    if (typeof obj != "object" || obj === null || !x in obj) return false;
    obj = obj[x];
    return true;
  });
}

export const clearStorage = () => {
  const localStorageKeys = Object.keys(localStorage);

  const mustBeStoredLocalStorages = [
    // LocalStorage Keys For Ones You Dont Want To Lose Ever :(
    "dismissGpsInfo",
  ];

  localStorageKeys.forEach((storageName) => {
    if (!mustBeStoredLocalStorages.includes(storageName)) {
      // Protect Loved Ones From Deleting From LocalStorage :)
      localStorage.removeItem(storageName);
    }
  });

  sessionStorage.clear();
};

export function just_digit(str) {
  const p = /^\d+$/;
  return p.test(str);
}

export const justEnglishLetterAndNumbers = (value) => {
  let result = true;
  if (typeof value === "undefined") {
    result = false;
  } else if (!/^[a-zA-Z0-9]+$/.test(value)) {
    result = false;
  }
  return result;
};

export function forceSWupdate() {
  console.log("force update is running");
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      for (let registration of registrations) {
        registration.update();
        console.log("sw is updating");
      }
    });
  } else {
    window.location.reload(true);
  }

  console.log("now redirect");
  window.location.href = window.location.origin + window.location.pathname;
}

export function isValidNationalCode(input) {
  if (!/^\d{10}$/.test(input)) {
    return false;
  }

  let check = +input[9];
  let sum = 0;
  let i;
  for (i = 0; i < 9; ++i) {
    sum += +input[i] * (10 - i);
  }
  sum %= 11;

  return (sum < 2 && check === sum) || (sum >= 2 && check + sum === 11);
}

export function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function errorMessageHandler(error) {
  if (
    hasOwnNestedProperty(error, "response.data.errors") &&
    error.response.data.errors !== undefined &&
    error.response.data.errors !== null &&
    error.response.data.errors.length > 0
  ) {
    let errors = "";
    error.response.data.errors.forEach((errorText) => {
      errors += errorText.message + "\r\n";
    });
    return errors;
  } else if (
    hasOwnNestedProperty(error, "response.data.message") &&
    error.response.data.message !== undefined &&
    error.response.data.message !== "" &&
    error.response.data.message !== null
  ) {
    return error.response.data.message;
  } else if (
    hasOwnNestedProperty(error, "data.message") &&
    error.data.message !== undefined &&
    error.data.message !== "" &&
    error.data.message !== null
  ) {
    return error.data.message;
  } else {
    console.error("error", error);
    return "Error sending information";
  }
}

export function getBase64(file) {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {};
  reader.onerror = function (error) {};
}

export function tourGuideSteps(setIsTourOpen) {
  const tourGuideStepsStyle = {
    backgroundColor: "#43756a",
  };

  return [
    {
      selector: ".icons_home",
      content: ({ goTo, inDOM }) => (
        <div className="tourGuideCard" onClick={() => goTo(1)}>
          <h3 style={{ color: "#fff" }}>ثبت درخواست مشاوره</h3>
          <p style={{ color: "#f8f9fa" }}>
            با انتخاب این گزینه , می توانید درخواست های مشاوره خود را ارسال کنید
          </p>
        </div>
      ),
      position: "top",
      style: tourGuideStepsStyle,
    },
    {
      selector: ".icons_archive",
      content: ({ goTo, inDOM }) => (
        <div className="tourGuideCard" onClick={() => goTo(2)}>
          <h3 style={{ color: "#fff" }}>لیست مشاوره ها</h3>
          <p style={{ color: "#f8f9fa" }}>
            با انتخاب این گزینه وارد بخش مشاوره میشوید
          </p>
        </div>
      ),
      position: "top",
      style: tourGuideStepsStyle,
    },
    {
      selector: ".icons_wiki",
      content: ({ goTo, inDOM }) => (
        <div className="tourGuideCard" onClick={() => goTo(3)}>
          <h3 style={{ color: "#fff" }}>سامانه جامع اطلاعات حقوقی</h3>
          <p style={{ color: "#f8f9fa" }}>
            با انتخاب این گزینه , به سامانه جامع اطلاعات حقوقی دسترسی دارید
          </p>
        </div>
      ),
      position: "top",
      style: tourGuideStepsStyle,
    },
    {
      selector: ".icons_lbs",
      content: ({ goTo, inDOM }) => (
        <div className="tourGuideCard" onClick={() => goTo(4)}>
          <h3 style={{ color: "#fff" }}>خدمات مبتنی بر مکان</h3>
          <p style={{ color: "#f8f9fa" }}>
            با انتخاب این گزینه به خدمات مبتنی بر مکان دسترسی دارید
          </p>
        </div>
      ),
      position: "top",
      style: tourGuideStepsStyle,
    },
    {
      selector: ".icons_menu",
      content: ({ goTo, inDOM }) => (
        <div
          className="tourGuideCard"
          onClick={() => {
            localStorage.setItem("not-first-usage", JSON.stringify(true));
            setIsTourOpen(false);
          }}
        >
          <h3 style={{ color: "#fff" }}>منو</h3>
          <p style={{ color: "#f8f9fa" }}>
            با انتخاب این گزینه به منو دسترسی دارید
          </p>
        </div>
      ),
      position: "top",
      style: tourGuideStepsStyle,
    },
  ];
}

export const getImageSize = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () =>
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = (error) => {
      reject(error);
    };
    img.src = src;
  });
};

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export function objectToFormData(obj, form, namespace) {
  let fd = form || new FormData();
  let formKey;

  for (let property in obj) {
    if (obj.hasOwnProperty(property)) {
      if (namespace) {
        formKey = namespace + "[" + property + "]";
      } else {
        formKey = property;
      }

      // if the property is an object, but not a File,
      // use recursivity.
      if (
        typeof obj[property] === "object" &&
        !(obj[property] instanceof File)
      ) {
        objectToFormData(obj[property], fd, property);
      } else {
        // if it's a string or a File object
        fd.append(formKey, obj[property]);
      }
    }
  }

  return fd;
}

export function objectToUrlParams(obj) {
  let str = "";
  for (let key in obj) {
    if (str !== "") {
      str += "&";
    }
    str += key + "=" + encodeURIComponent(obj[key]);
  }
  return str;
}

export function b64toBlob(b64Data, contentType = "", sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

export function trimDoubleQuotes(string) {
  return string.replace(/(^")|("$)/g, "");
}

export function detectIos() {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}

export const validateNationalCode = (rule, value, callback) => {
  if (value) {
    const ncStatus = isValidNationalCode(value);
    if (value && ncStatus) {
      callback();
    } else {
      callback(`کد ملی نا صحیح است`);
    }
  } else {
    callback();
  }
};

export const convertUnixToPersianDate = (unixDate, formatText) => {
  let date = moment.unix(unixDate / 1000);
  let persiandate = date.format(formatText);
  return persiandate;
};

export const convertSecondToTime = (val) => {
  if (val !== 0) {
    let value;
    if (val < 0) {
      value = Math.abs(val);
    } else {
      value = val;
    }
    const sec = parseInt(value, 10); // convert value to number if it's string
    let hours = Math.floor(sec / 3600); // get hours
    let minutes = Math.floor((sec - hours * 3600) / 60); // get minutes
    let seconds = sec - hours * 3600 - minutes * 60; //  get seconds
    // add 0 if value < 10; Example: 2 => 02
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    if (val < 0) {
      return hours + ":" + minutes + ":" + seconds + "-";
    } else {
      return hours + ":" + minutes + ":" + seconds;
    }

    // return `${hours}:${minutes}:${seconds}`;
    // return moment.utc(data * 1000).format(`HH:mm:ss`);
  }
};

export function downloadWithAxios(url, name, setLoading = () => {}) {
  setLoading(true);

  axios({
    url,
    method: "GET",
    responseType: "blob", // Important
  })
    .then((r) => {
      FileDownload(r.data, name);
      setLoading(false);
    })
    .catch((e) => {
      message.error("خطا در دریافت فایل");
      setLoading(false);
    });
}

export const LogoutMechanism = () => {
  localStorage.clear();
  window.location.href = "login";
};
